import DataServices from "../../services/DataServices";
import Auth from "../../methods/Auth";
import { addItem, getAllItems, clearStore} from "../../services/AdminDBService"
import { clearAllStores as clearCsDB } from '../../services/CsDBService';
import { clearAllStores as clearEventsDB } from '../../services/EventsDBService';
import { clearAllStores as clearFilingsDB } from '../../services/FilingsDBService';
import { clearAllStores as clearEsgDB } from '../../services/EsgDBService';
import { clearAllStores as clearEstDB } from '../../services/EstDBService';
import { clearAllStores as clearNewsDB } from '../../services/NewsDBService';
import { clearAllStores as clearSnapshotDB } from '../../services/SnapshotDBService';
import { clearAllStores as clearLipperDB } from '../../services/LipperDBService';
import { clearAllStores as clearOwnershipDB } from '../../services/OwnershipDBService';
import { clearAllStores as ClearStreamingDB } from '../../services/StreamingDBService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const tabName = "fileVersions";

export async function fetchData(){
  return await getAllItems(tabName);
}

export async function getDownloadLink(filename){
  try {
    const url = API_BASE_URL + 'file-versions-handler' ;
    const data = {
      "query": "downloadFile",
      "filename": filename
    };
    const response = await DataServices.sendPostRequest(url, data);
    return response.data;
  } catch (error) {
    console.error('Error fetching download link:', error);
    return null;
  }
}

export function formatDate(timestamp){
  // Format timestamp to "MMM DD, YYYY HH:mm"
  const date = new Date(timestamp);
  const options = { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' };
  return date.toLocaleString('en-US', options).replace(',', '');
}

export async function fetchUsers() {
  try {
    const data = {
      "proj_alias": "Rajc03er9g"
    };
    const response = await DataServices.sendiRPMRequest('list-users-by-project/', data);

    return(response.data.d[0]["users_and_roles"]["users"]);
  } catch (error) {
    console.error('Error fetching users:', error);
    return [];
  }
}

export async function fetchApprovals() {
  try {
    const data = {
      "trid": Auth.currentUser.trid,
      "all": "0"
    };
    const response = await DataServices.sendiRPMRequest('list-own-role-apply/', data);
    return(response.data.d);
  } catch (error) {
    console.error('Error fetching approvals:', error);
    return [];
  }
}

export async function updateUserRoles(userId, roles) {
  const roleIds = [67032, 67036, 69018]; // Owner, Admin, User role IDs
  let rolesString = "";
  for (let i = 0; i < 3; i++) {
    if (roles[i]) {
      rolesString += String(roleIds[i]) + ",";
    }
  }
  if (rolesString.endsWith(",")) {
    rolesString = rolesString.slice(0, -1);
  }
  try {
    const data = {
      "uid": userId,
      "role_ids": rolesString,
      "proj_id": 800
    };
    const response = await DataServices.sendiRPMRequest('overwrite-user-role/', data);
    return(response.data);
  } catch (error) {
    console.error('Error updating user roles:', error);
    return null;
  }
}

export async function removeUser(userId) {
  try {
    const data = {
      "uid": userId,
      "proj_ids": "800"
    };
    const response = await DataServices.sendiRPMRequest('remove-user-from-proj/', data);
    return(response.data);
  } catch (error) {
    console.error('Error removing user:', error);
    return null;
  }
}

export async function approveUser(userId) {
  try {
    const data = {
      "uids": [userId],
      "role_ids": [69018] // User role ID
    };
    const response = await DataServices.sendiRPMRequest('approve-role/', data);
    return(response.data);
  } catch (error) {
    console.error('Error approving user:', error);
    return null;
  }
}

export async function rejectUser(userId) {
  try {
    const data = {
      "uids": [userId],
      "role_ids": [69018] // User role ID
    };
    const response = await DataServices.sendiRPMRequest('deny-role/', data);
    return(response.data);
  } catch (error) {
    console.error('Error rejecting user:', error);
    return null;
  }
}

function clearDBStore(tabValue){
  if(tabValue === "company_snapshot"){
    clearCsDB();
  }else if(tabValue === "events"){
    clearEventsDB();
  }else if(tabValue === "filings"){
    clearFilingsDB();
  }else if(tabValue === "esg"){
    clearEsgDB();
  }else if(tabValue === "estimates"){
    clearEstDB();
  }else if(tabValue === "news"){
    clearNewsDB();
  }else if(tabValue === "snapshot_quotes"){
    clearSnapshotDB();
  }else if(tabValue === "lipper_funds"){
    clearLipperDB();
  }else if(tabValue === "ownership"){
    clearOwnershipDB();
  }else if(tabValue === "streaming_quotes"){
    ClearStreamingDB();
  }
}

function addKeypath(data){
  return data.map((item, index) => ({
    ...item,
    id: `${item.filename || "item"}-${item.version || 0}-${item.updatedAt || index}`
  }));
}

export async function syncVersions(){
  async function fetchData(){
    const url = API_BASE_URL + 'file-versions-handler?query=getAllVersions';
    return await DataServices.sendGetRequest(url);
  }
  try {
    const serverResponse = await fetchData();
    const serverItems = serverResponse.data.items;
    const localItems = await getAllItems(tabName) || [];
    const tabs = ["company_snapshot", "events", "filings", "esg", "estimates", "news", "snapshot_quotes", "lipper_funds", "ownership"];

    if(!localItems || localItems.length === 0){
      await addItem(tabName, addKeypath(serverItems));
      return;
    }else if(serverItems.length !== localItems.length){
      for(let tab of tabs){
        if(serverItems.filter(item => item.filename === tab).length > localItems.filter(item => item.filename === tab).length){
          clearDBStore(tab);
        }
      }
      
      await clearStore(tabName);
      await addItem(tabName, addKeypath(serverItems));
      return;
    }
    
  } catch (error) {
    console.error('Error in syncVersions:', error);
  }
}
